<script setup lang="ts">
import UtilizationChart from './Chart/UtilizationChart.vue'
import UtilizationAmountChart from './Chart/UtilizationAmountChart.vue'
import ComsuptionChart from './Chart/ComsuptionChart.vue'
import DemandChart from './Chart/DemandChart.vue'
import UtilizationWithGolsChart from './Chart/UtilizationWithGolsChart.vue'
import ReportCorrelatedChartsBlock from './Chart/ReportCorrelatedChartsBlock.vue'
import { useReportStore } from '@/store/report.ts'
import { storeToRefs } from 'pinia'
import AlarmAnalysisCharts from './Chart/AlarmAnalysisCharts.vue'
import { computed } from 'vue'

const { hasEnergyData, hasCorrelatedChartsBase, hasCorrelatedChartsCompare } = storeToRefs(useReportStore())

const hasCorrelatedCharts = computed(
  () => hasCorrelatedChartsBase.value || hasCorrelatedChartsCompare.value,
)
</script>

<template>
  <div class="flex min-w-0 flex-col gap-6 p-6 lg:px-8">
    <div v-if="hasEnergyData" class="flex flex-col gap-6">
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        <ComsuptionChart />
        <UtilizationChart />
        <DemandChart />
      </div>

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div class="lg:col-span-1">
          <UtilizationAmountChart />
        </div>
        <div class="lg:col-span-2">
          <UtilizationWithGolsChart />
        </div>
      </div>
    </div>

    <ReportCorrelatedChartsBlock v-if="hasCorrelatedCharts" />

    <AlarmAnalysisCharts />
  </div>
</template>
